export class CommonConstants {
  static readonly MASKED_RATE = -1;
}
